import { TooltipProps } from "@mui/material/Tooltip";
import { BlTooltip } from "Components/Shared/BlTooltip";
import { InfoIcon } from "Components/Shared/Icons";
import * as React from "react";
import styled from "styled-components";

type Props = Omit<TooltipProps, "children"> & {
  tooltipColor?: {
    background: string;
    text: string;
  };
  iconColor?: string;
  maxWidth?: number | null;
  maxHeight?: number | null;
};

const StyledIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 16px;
    height: auto;
  }
`;

export const BlDefaultTooltip: React.FunctionComponent<Props> = props => {
  return (
    <BlTooltip {...props}>
      <StyledIcon>
        <InfoIcon color={props.iconColor} />
      </StyledIcon>
    </BlTooltip>
  );
};
